{
  "Sidebar": {
    "badges": {
      "beta": "Beta"
    },
    "guest": {
      "title": "Salva il tuo lavoro",
      "description": "Accedi gratuitamente per salvare in modo permanente i tuoi esami, le chat e le impostazioni.",
      "loginButton": "Accedi ora"
    },
    "actions": {
      "newExamTitle": "Crea un nuovo esame",
      "creating": "Creazione in corso...",
      "newExam": "Nuovo esame"
    },
    "examList": {
      "title": "I miei esami",
      "noExams": "Nessun esame trovato.",
      "unnamed": "Senza nome",
      "unnamedExam": "Esame senza nome",
      "loadOlder": "Carica esami meno recenti"
    },
    "examMenu": {
      "edit": "Modifica",
      "addToClass": "Aggiungi alla classe",
      "delete": "Elimina"
    },
    "bottomNav": {
      "profile": "Profilo",
      "settings": "Impostazioni",
      "feedback": "Invia feedback"
    },
    "dialogs": {
      "renameTitle": "Modifica esame",
      "groupTitle": "Raggruppa esame",
      "renameDesc": "Modifica le informazioni dell'esame.",
      "groupDesc": "Seleziona una classe o un gruppo per questo esame.",
      "fields": {
        "name": "Nome",
        "subject": "Materia",
        "topic": "Argomento",
        "class": "Classe",
        "placeholderSelect": "Seleziona..."
      },
      "save": "Salva"
    },
    "alerts": {
      "deleteConfirm": "Vuoi davvero eliminare questo esame?",
      "saveFailed": "Salvataggio fallito"
    }
  },
  "Settings": {
    "title": "Impostazioni",
    "soon": "Prossimamente",
    "DisplayAndLanguage": {
      "title": "Visualizzazione e Lingua",
      "languageLabel": "Lingua",
      "languageDesc": "Scegli la lingua dell'interfaccia utente.",
      "themeLabel": "Aspetto",
      "themeDesc": "Passa dalla modalità chiara a quella scura."
    },
    "AI": {
      "title": "IA e Valutazione",
      "strictnessLabel": "Incertezza dell'IA",
      "strictnessDesc": "Determina a quale livello di confidenza dell'IA è obbligatoria la revisione manuale.",
      "strictnessWarning": "Avvertenza: Con \"Alta Autonomia\", si interviene manualmente solo quando l'IA è molto incerta...",
      "gradingKindnessLabel": "Rigore della Valutazione",
      "gradingKindnessDesc": "Determina quanto rigorosamente l'IA applica lo schema di valutazione. Indulgente favorisce lo studente nei casi limite; Severo segue lo schema alla lettera.",
      "gradingKindnessOptions": {
        "lenient": "Indulgente",
        "balanced": "Equilibrato",
        "strict": "Severo"
      }
    },
    "Notifications": {
      "title": "Notifiche",
      "soon": "Prossimamente",
      "emailLabel": "Notifiche e-mail",
      "emailDesc": "Ricevi notifiche e-mail su eventi importanti",
      "browserLabel": "Notifiche del browser",
      "browserDesc": "Ricevi notifiche push direttamente nel tuo browser"
    },
    "About": {
      "title": "Informazioni su Gradias",
      "landingPage": "Visita gradias.ai",
      "support": "Aiuto e supporto",
      "imprint": "Note legali",
      "privacy": "Informativa sulla privacy"
    },
    "Account": {
      "title": "Dati e Account",
      "exportLabel": "Esporta i miei dati",
      "exportDesc": "Scarica tutti gli esami caricati e i risultati in un file ZIP",
      "deleteLabel": "Elimina il mio account",
      "deleteDesc": "Elimina definitivamente i tuoi dati e tutte le informazioni associate"
    }
  },
  "Profile": {
    "title": "Profilo",
    "actions": {
      "cancel": "Annulla",
      "save": "Salva",
      "edit": "Modifica"
    },
    "alerts": {
      "saveError": "Impossibile salvare il profilo.",
      "generalError": "Si è verificato un errore."
    },
    "personal": {
      "firstName": "Nome",
      "lastName": "Cognome",
      "name": "Nome",
      "school": "Scuola",
      "noSchool": "Nessuna scuola specificata",
      "email": "E-mail",
      "emailHint": "L'e-mail non può essere modificata qui.",
      "defaultUser": "Utente",
      "role": {
        "teacher": "Insegnante",
        "student": "Studente"
      }
    },
    "teaching": {
      "subjects": "Le mie materie"
    },
    "rules": {
      "title": "Regole e Preferenze",
      "description": "Preferenze salvate che l'assistente segue durante le chat, le valutazioni e la creazione di soluzioni modello e schemi di valutazione. Puoi modificarle qui, ma l'assistente può anche adattarle direttamente nella chat se lo richiedi.",
      "general": "Generale",
      "empty": "Nessuna regola ancora salvata.",
      "addRule": "Aggiungi regola",
      "removeRule": "Rimuovi regola",
      "limitReached": "Limite raggiunto",
      "limitHint": "Massimo {{max}} regole per categoria",
      "placeholder": "Descrivi la regola...",
      "categories": {
        "chat_and_workflow": "Chat e Flusso di lavoro",
        "grading_and_feedback": "Valutazione e Feedback",
        "master_solution_design": "Soluzioni modello",
        "grading_scheme_creation": "Schemi di valutazione"
      },
      "categoryDescs": {
        "chat_and_workflow": "Come l'assistente risponde nella chat e gestisce il flusso di lavoro",
        "grading_and_feedback": "Come vengono valutate le risposte e come viene formulato il feedback",
        "master_solution_design": "Come vengono create le soluzioni modello",
        "grading_scheme_creation": "Come vengono strutturati gli schemi di valutazione"
      },
      "grammar": {
        "alwaysUseFi": "Usa sempre l'indice di errori (FI)",
        "alwaysUseFiDesc": "Per impostazione predefinita, usa l'indice di errori invece di eventuali regole di grammatica rilevate da uno schema di valutazione caricato. Può essere sovrascritto per singolo esame.",
        "languageUseRegradeWordCutoff": "Rivalutazione automatica della competenza linguistica da (parole)",
        "languageUseRegradeWordCutoffDesc": "Quando si modifica la risposta di uno studente, la competenza linguistica del gruppo interessato viene rivalutata automaticamente non appena sono state modificate almeno questo numero di parole (più piccole modifiche si sommano).",
        "contentRegradeWordCutoff": "Rivalutazione automatica del contenuto da (parole)",
        "contentRegradeWordCutoffDesc": "0 = sempre (predefinito): il contenuto viene rivalutato immediatamente a ogni modifica del testo. Un valore più alto salta la rivalutazione automatica per modifiche molto piccole."
      }
    },
    "security": {
      "title": "Account e Sicurezza",
      "changePassword": "Cambia password",
      "changePasswordDesc": "Gestisci la sicurezza del tuo account",
      "logout": "Disconnetti",
      "logoutDesc": "Disconnetti in modo sicuro da questo dispositivo"
    },
    "badges": {
      "soon": "Prossimamente"
    }
  },
  "ClassInsights": {
    "overview": "Panoramica",
    "examCount": "Esami",
    "subjectCount": "Materie",
    "gradedCount": "Valutati",
    "examListTitle": "Esami in questa classe",
    "noExams": "Ancora nessun esame in questa classe.",
    "loading": "Caricamento degli approfondimenti …",
    "statusGraded": "Valutato",
    "statusInProgress": "In corso",
    "unnamedExam": "Esame senza titolo",
    "unknownSubject": "Materia sconosciuta"
  },
  "Dashboard": {
    "guestMessage": "Sono gradi, il tuo assistente IA per la correzione degli esami.",
    "greetings": {
      "opt1": "Quali esami correggiamo oggi?",
      "opt2": "Smaltiamo questa pila di esami.",
      "opt3": "Cosa c'è in programma oggi?",
      "opt4": "Come posso aiutarti oggi?",
      "opt5": "Felice di vederti. Da cosa iniziamo?",
      "opt6": "Iniziamo a correggere!"
    },
    "fallbackGreeting": "Cosa c'è in programma oggi?",
    "greetingPrefix": "Ciao",
    "inputPlaceholder": "Fai una domanda...",
    "dropzoneText": "Trascina i file qui",
    "actions": {
      "startGrading": {
        "label": "Avvia correzione esame",
        "prompt": "Vorrei avviare una nuova correzione di un esame. Per favore, guidami passo dopo passo nel processo, dal caricamento allo schema di valutazione."
      },
      "howItWorks": {
        "label": "Come funziona gradias?",
        "prompt": "Spiegami brevemente e chiaramente come funziona gradias e quali passaggi devo seguire per una correzione corretta."
      },
      "sampleData": {
        "label": "Testa con dati di esempio",
        "prompt": "Voglio testare il sistema ma non ho esami miei a disposizione. Come posso fare un test con un esame di esempio?"
      },
      "taskTypes": {
        "label": "Quali tipi di esercizi ci sono?",
        "prompt": "Quali tipi di esercizi (ad es. testo libero, scelta multipla, equazioni matematiche) puoi correggere attualmente?"
      },
      "privacy": {
        "label": "Privacy e sicurezza",
        "prompt": "In che modo gradias gestisce la privacy dei dati? Cosa succede agli esami caricati dai miei studenti?"
      }
    },
    "alerts": {
      "uploadError": "Errore durante il caricamento del file",
      "noExamId": "Nessun ID esame presente"
    },
    "aria": {
      "uploadFiles": "Carica file",
      "submit": "Invia",
      "removeFile": "Rimuovi file"
    }
  },
  "ChatInput": {
    "statusLabels": {
      "allComplete": "Tutti i passaggi completati",
      "configRunning": "Pronto - Pronto per continuare",
      "readyForConfig": "Pronto per la configurazione",
      "status": "Stato",
      "progress": "Progresso",
      "inProgress": "in corso"
    },
    "steps": {
      "examCreator": {
        "label": "Crea esame",
        "phasePlan": "Pianificazione dell'esame",
        "phaseMaterial": "Generazione delle figure",
        "phaseSource": "Scrittura degli esercizi",
        "phaseRepair": "Finalizzazione del documento"
      },
      "upload": {
        "label": "Caricamento file"
      },
      "studentAssignment": {
        "label": "Assegnazione studenti",
        "activeWait": "In attesa di conferma",
        "activeAssign": "Assegna le consegne degli studenti"
      },
      "structure": {
        "label": "Struttura dell'esame",
        "active": "Rilevamento esercizi in corso"
      },
      "answers": {
        "label": "Risposte degli studenti",
        "active": "Elaborazione risposte in corso"
      },
      "masterSolution": {
        "label": "Soluzione modello",
        "activeDetect": "Rilevamento soluzione modello in corso",
        "activeCreate": "Creazione soluzione modello in corso",
        "activeComplete": "Completamento della soluzione modello"
      },
      "gradingScheme": {
        "label": "Criteri di valutazione",
        "activeDetect": "Rilevamento criteri di valutazione in corso",
        "activeCreate": "Creazione criteri di valutazione in corso",
        "activeComplete": "Completamento dei criteri di valutazione"
      },
      "grading": {
        "label": "Correzione",
        "active": "Correzione in corso"
      },
      "summary": {
        "label": "Riepilogo dei risultati"
      }
    },
    "badges": {
      "uncertainties": "Incertezze",
      "errorRegions": "Regioni con errori",
      "errorSubmissions": "Consegne con errori",
      "documentEncrypted": "Documento crittografato"
    },
    "ui": {
      "showProgress": "Mostra progresso della correzione",
      "dropFilesHere": "Trascina i file qui",
      "uploadFiles": "Carica file",
      "waitUpload": "Attendi il caricamento",
      "sendMessage": "Invia messaggio",
      "privacyNotice": "Conforme al 100% al GDPR. I tuoi dati e i documenti degli studenti non vengono utilizzati per l'addestramento dell'IA.",
      "learnMore": "Scopri di più."
    },
    "alerts": {
      "uploadError": "Errore durante il caricamento del file",
      "noExamId": "Nessun ID esame presente"
    }
  },
  "TokenInput": {
    "placeholder": "Fai una domanda..."
  },
  "Chat": {
    "auth": {
      "login": "Accedi",
      "register": "Registrati"
    },
    "loading": {
      "masterSolutions": "Caricamento soluzioni modello...",
      "examData": "Caricamento dati esame e immagini...",
      "extractingTasks": "Estrazione esercizi... {{finished}}/{{total}}",
      "splitThinkingMessage": "Sto organizzando le consegne degli studenti",
      "structureThinkingMessage": "Sto rilevando la struttura dell'esame",
      "examStructure": "Caricamento struttura dell'esame...",
      "pages": "Caricamento pagine...",
      "summary": "Caricamento riepilogo..."
    },
    "alerts": {
      "errorOccurred": "Spiacenti, si è verificato un errore. Riprova più tardi.",
      "reportsBlocked": "I report PDF sono disponibili solo quando tutti i compiti principali sono approvati o se la sicurezza dell'IA è superiore al {{threshold}}%.",
      "noSubmissionsForReports": "Nessuna consegna con dati di report trovata.",
      "reportsFailed": "Impossibile generare i report PDF. Riprova."
    },
    "sampleExamIntro": "Vorrei correggere questo esame con i seguenti documenti:\n{{lines}}",
    "canvasTitles": {
      "boundingbox": "Regola le aree degli esercizi",
      "msedit": "Modifica soluzione modello / schema di valutazione",
      "correction": "Correzione",
      "summary": "Riepilogo della correzione",
      "structureeditor": "Modifica la struttura dell'esame",
      "submissioncheck": "Verifica l'assegnazione delle pagine",
      "demoselector": "Seleziona demo",
      "examcreator": "Crea esame",
      "default": "Vista dettagliata"
    }
  },
  "Canvas": {
    "common": {
      "resize": "Regola dimensioni",
      "toSummaryTitle": "Al riepilogo",
      "backToSummary1": "Torna al",
      "backToSummary2": "Riepilogo",
      "restore": "Ripristina",
      "fullscreen": "Schermo intero",
      "close": "Chiudi"
    },
    "grading": {
      "prevTask": "Esercizio precedente",
      "nextTask": "Esercizio successivo",
      "taskXofY": "Esercizio {{current}} di {{total}}",
      "taskName": "Esercizio {{number}}",
      "nextUncertainty": "Prossima incertezza ({{count}})",
      "uncertaintiesLeft": "{{count}} incertezze rimaste",
      "backToSummary1": "Torna al",
      "backToSummary2": "Riepilogo",
      "submissionX": "Consegna {{id}}",
      "pages": "Pagine:",
      "pageX": "Pagina {{page}}",
      "addBoundingBox": "Aggiungi nuova bounding box",
      "extractedText": "Testo estratto",
      "verified": "Verificato",
      "consistencyAdjusted": "Adattato automaticamente per coerenza con altre consegne",
      "bboxConfidence": "Sicurezza BBox: {{conf}}%",
      "review": "Revisiona",
      "noTextExtracted": "Nessun testo estratto.",
      "imageContent": "Immagine (nessun riconoscimento del testo) - la sezione dell'immagine rilevata verrà utilizzata direttamente per l'ulteriore elaborazione",
      "aiGrading": "Valutazione dell'IA",
      "pts": "Pt.",
      "points": "Punti:",
      "noGradingYet": "Nessuna valutazione ancora disponibile.",
      "gradingScheme": "Schema di valutazione",
      "expand": "Espandi",
      "collapse": "Riduci",
      "maxPoints": "Punti max: {{points}}",
      "noGradingSchemeYet": "Nessuno schema di valutazione ancora disponibile.",
      "boxModeContent": "Contenuto",
      "boxModeLanguageUse": "Competenza linguistica",
      "groupLanguageUseRule": "Gruppo: compito {{tasks}}",
      "groupLanguageUseRuleNumbered": "Gruppo {{number}}: compito {{tasks}}",
      "editLanguageUseGroupTasks": "Modifica le attività di questo gruppo",
      "deleteLanguageUseGroup": "Elimina questa regola di competenza linguistica",
      "deleteLanguageUseGroupConfirm": "Eliminare questa regola di competenza linguistica? Questa azione non può essere annullata.",
      "deleteLanguageUseGroupBlocked": "Non è possibile eliminare durante la correzione.",
      "languageUseGroupPickerInfo": "Seleziona un'attività per aggiungerla a questo gruppo. Deselezionala per rimuoverla; se necessita ancora di una propria regola di competenza linguistica, viene precompilata con il testo di questo gruppo e 0 punti così puoi ritrovarla.",
      "languageUseGroupPickerSaveFailed": "Salvataggio non riuscito. Riprova.",
      "languageUseGroupPickerEmptyDraft": "Una regola richiede almeno un'attività.",
      "deleteBox": "Elimina bounding box",
      "retryOcr": "Riprova riconoscimento del testo",
      "unlockBox": "Sblocca bounding box",
      "lockBox": "Blocca bounding box",
      "noSubmissionsFound": "Nessuna consegna trovata.",
      "examPageX": "Pagina dell'esame {{page}}",
      "rerunningOcr": "Ripetizione del riconoscimento del testo...",
      "regrading": "Nuova valutazione in corso...",
      "regradingQueued": "In coda..."
    },
    "msgs": {
      "noTasksFound": "Nessun esercizio trovato.",
      "prevTask": "Esercizio precedente",
      "nextTask": "Esercizio successivo",
      "task": "Esercizio",
      "taskMain": "Esercizio {{main}}",
      "taskSub": "Esercizio {{main}}.{{sub}}",
      "uncertaintiesLeft": "{{count}} incertezze rimaste",
      "nextUncertainty": "Prossima incertezza ({{count}})",
      "taskExcerpt": "Estratto dell'esercizio",
      "noImageAvailable": "Nessuna immagine disponibile...",
      "masterSolution": "Soluzione modello",
      "aiGeneratedProposalTooltip": "Suggerimento generato dall'IA",
      "aiGeneratedProposal": "Suggerimento generato dall'IA",
      "review": "Revisiona",
      "approvalRequiresPoints": "L'approvazione è possibile solo quando il punteggio è maggiore di 0.",
      "saveRequiresPoints": "Il salvataggio è possibile solo quando il punteggio è maggiore di 0.",
      "enterMasterSolution": "Inserisci la soluzione modello qui...",
      "noMasterSolutionYet": "Nessuna soluzione modello ancora disponibile...",
      "gradingScheme": "Schema di valutazione",
      "maxPoints": "Punti max",
      "maxPointsValue": "Punti max: {{points}}",
      "enterGradingScheme": "Inserisci lo schema di valutazione qui...",
      "noGradingSchemeYet": "Nessuno schema di valutazione ancora disponibile...",
      "gradingSchemeRefining": "Aggiornamento dei criteri di valutazione...",
      "masterSolutionRefining": "Aggiornamento della soluzione modello..."
    },
    "submissionCheck": {
      "pageShort": "Pag. {{page}}",
      "zoomPage": "Ingrandisci pagina {{page}}",
      "pageAlt": "Pagina",
      "loading": "Carregando...",
      "newStudent": "Nuovo studente",
      "readOnly": "Solo lettura",
      "saveAssignment": "Salva assegnazione",
      "unassignedPagesTitle": "Richiede chiarimento: Pagine non assegnate ({{count}})",
      "unassignedPagesHint": "Trascina queste pagine nelle cartelle degli studenti.",
      "newStudentIndexed": "Nuovo studente {{index}}",
      "studentIndexed": "Studente {{index}}",
      "enterName": "Inserisci il nome...",
      "pageX_one": "{{count}} pagina",
      "pageX_other": "{{count}} pagine",
      "splitConfidenceHover": "Fiducia di divisione: {{percent}}%",
      "splitPercent": "Divisione {{percent}}%",
      "deleteStudent": "Elimina studente",
      "dragHint": "Trascina i documenti qui per assegnarli a {{name}}",
      "assignmentNotes": "Note sull'assegnazione",
      "previewPageAlt": "Anteprima pagina {{page}}",
      "pageCurrentOfTotal": "Pagina {{current}} di {{total}}",
      "locked": "Confermato",
      "lockedHint": "Già confermato – non può più essere modificato."
    },
    "summary": {
      "studentsOverview": "Riepilogo per studente",
      "studentsOverviewDesc": "Punti dettagliati e valutazione dell'IA per esercizio",
      "searchStudent": "Cerca nome studente...",
      "student": "Studente",
      "pointsAbbr": "P.",
      "total": "Totale",
      "percentage": "Percentuale",
      "grade": "Voto",
      "noHits": "Nessun risultato.",
      "aiConfidenceHover": "Sicurezza IA: {{percent}}% - Verificare manualmente",
      "aiUncertainties": "Incertezze dell'IA",
      "aiUncertaintiesDesc": "Controlla i casi in cui l'IA è incerta per garantire valutazioni eque.",
      "openDecisions": "{{count}} decisioni in sospeso",
      "sortBy": "Ordina per",
      "task": "Esercizio",
      "aiUncertainty": "Incertezza dell'IA",
      "confidence": "Sicurezza IA:",
      "points": "Punti:",
      "toGrading": "Vai alla correzione",
      "confirmed": "Confermato",
      "confirm": "Conferma",
      "noClarificationNeeded": "Nessun chiarimento necessario.",
      "worstAvg": "Media peggiore",
      "noDataYet": "Nessun dato ancora disponibile",
      "avgSuffix": "in media",
      "frequentErrors": "Fonti di errore più frequenti",
      "metricsPerTask": "Metriche per esercizio",
      "gradeDistribution": "Distribuição de notas",
      "count": "Conteggio",
      "pdfReports": "Report PDF",
      "downloadingPdf": "Generazione dei report PDF in corso...",
      "downloadPdf": "Scarica i report PDF",
      "csvExport": "Esportazione dei voti in CSV",
      "notConnected": "Non ancora connesso",
      "notMet": "Non soddisfatto",
      "downloadingCsv": "Generazione CSV in corso...",
      "downloadCsv": "Scarica CSV",
      "gradeScale": "Scala dei voti",
      "gradeFrom": "Voto {{grade}} da",
      "normalDistribution": "Distribuzione normale (Curva di Gauss)",
      "activated": "Attivato",
      "deactivated": "Disattivato",
      "curveStrength": "Intensità della curva",
      "curvingComingSoon": "La funzione di curva non è ancora disponibile. Arriverà presto.",
      "noSubmissionsFound": "Nessuna consegna corretta trovata.",
      "avgPointsReached": "Ø Punti ottenuti",
      "pointsReached": "Punti ottenuti",
      "gradeSystem": "Sistema di valutazione",
      "gradeBorders": "Limiti dei voti",
      "lowestGradeLabel": "voto più basso (da 0%)",
      "tabs": {
        "students": "Panoramica studenti",
        "clarification": "Richiede chiarimento",
        "insights": "Insight degli esercizi",
        "grades": "Distribuzione dei voti",
        "curving": "Scala dei voti e Curva",
        "export": "Esporta",
        "languageUse": "Competenza linguistica & Grammatica"
      },
      "gradingScales": {
        "german16": "Tedesco (1–6)",
        "drittel": "Terzi (1.0–5.0)",
        "af": "A–F",
        "gpa4": "4.0 GPA",
        "notenpunkte": "Punti di voto (0–15)",
        "numeric10": "10 punti",
        "percentage": "Percentuale",
        "custom": "Personalizzato"
      },
      "grammar": "Grammatica",
      "fehlerindex": "Indice di errori (FI)",
      "grammarFiColumnHint": "Include solo i compiti ancora valutati tramite l'indice di errore; i compiti valutati tramite regole hanno colonne proprie.",
      "taskLanguageUseColumn": "{{label}} · Competenza linguistica",
      "grammarTab": {
        "noGrammarTasks": "Questo esame non contiene compiti con valutazione grammaticale.",
        "fiTitle": "Detrazione per indice di errori",
        "fiDesc": "Indice di errori = errori ogni 100 parole. Il superamento delle soglie abbassa il voto finale di uno o più gradini.",
        "fiUnsupportedScale": "Con una scala percentuale non è possibile detrarre gradini di voto.",
        "fiAbove": "Se l'indice di errori supera",
        "deductSteps": "detrarre (gradini di voto)",
        "matrixTitle": "Errori grammaticali per studente e compito",
        "matrixDesc": "Numero di errori (indice di errori tra parentesi). Cliccando su una cella si apre la correzione in modalità grammatica.",
        "fiSwitchTitle": "Applica l'indice di errori per questo esame",
        "fiSwitchDesc": "Usa per impostazione predefinita la tua impostazione del profilo; attiva per sovrascriverla solo per questo esame.",
        "gradeWithFi": "Voto (con IE)"
      },
      "languageUseTab": {
        "rulesOverviewTitle": "Regole di competenza linguistica utilizzate per la valutazione",
        "ownRuleEntry": "{{label}}: regola propria ({{points}} pt)",
        "groupRuleEntry": "{{label}} ({{points}} pt)",
        "teacherRulesActive": "La competenza linguistica viene valutata direttamente durante la correzione secondo le tue regole personali. La detrazione per indice di errori è disattivata."
      }
    },
    "structureEditor": {
      "pointsInconsistent": "I punti non corrispondono. A ogni livello assegna punti a tutte le attività (la cui somma sia pari al totale dell'attività superiore) oppure lasciale tutte vuote. Correggi le attività evidenziate:",
      "pointsInconsistentTask": "All'attività {{path}} mancano i punti",
      "totalPoints": "Punti totali (incl. sottoattività)",
      "ownPoints": "Punti propri (la risposta propria di questa attività)",
      "tasksWithoutRegion": "Attività senza area contrassegnata",
      "noPages": "Nessuna pagina disponibile.",
      "taskAreasDetected_one": "{{count}} area di esercizio rilevata",
      "taskAreasDetected_other": "{{count}} aree di esercizi rilevate",
      "addArea": "Aggiungi area",
      "remove": "Rimuovi",
      "resetZoom": "Ripristina zoom",
      "readOnly": "Solo lettura",
      "saving": "Salvataggio in corso...",
      "saved": "Salvato",
      "blankExamPage": "Pagina dell'esame in bianco {{page}}",
      "deleteBbx": "Elimina BBX",
      "retryOcr": "Riprova riconoscimento del testo",
      "noTasksOnPage": "Nessun esercizio su questa pagina",
      "task": "Esercizio",
      "noText": "Nessun testo",
      "imageContent": "Immagine (nessun riconoscimento del testo) - la sezione dell'immagine rilevata verrà utilizzata direttamente per l'ulteriore elaborazione",
      "additionalInfo": "Informazioni aggiuntive",
      "noContent": "Nessun contenuto",
      "linkedTasks": "Esercizi collegati",
      "noTasks": "Nessun esercizio"
    },
    "demoSelector": {
      "title": "Seleziona demo",
      "description": "Scegli un esame di esempio. gradias simulerà il caricamento e avvierà l'estrazione automaticamente.",
      "examCount_one": "{{count}} esame",
      "examCount_other": "{{count}} esami",
      "studentCount_one": "{{count}} studente",
      "studentCount_other": "{{count}} studenti",
      "examLanguage": "Lingua dell'esame",
      "subjects": {
        "math": "Matematica",
        "english": "Inglese",
        "technical": "Scuola professionale",
        "biology": "Biologia",
        "spanish": "Spagnolo",
        "french": "Francese",
        "physics": "Fisica",
        "political_education": "Educazione civica",
        "german": "Tedesco"
      },
      "grades": {
        "gesamtschule": "Scuola comprensiva",
        "highSchool": "Liceo",
        "elementarySchool": "Scuola elementare",
        "vocationalSchool": "Istruzione per adulti",
        "middleSchool": "Scuola media",
        "university": "Università",
        "primarySchool": "Scuola elementare"
      },
      "exams": {
        "kaarst": {
          "name": "Studio di funzioni (Matematica)",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "arne": {
          "name": "Frazioni - 6ª classe (Matematica)",
          "description": "Consegne degli studenti"
        },
        "lynehamMath": {
          "name": "Matematica",
          "description": "Consegne degli studenti"
        },
        "tuevBauleiter": {
          "name": "Direttore dei lavori",
          "description": "Consegne degli studenti e soluzione modello"
        },
        "tuvPhotovoltaik": {
          "name": "Fotovoltaico",
          "description": "Consegne degli studenti e soluzione modello"
        },
        "engVocabulary": {
          "name": "Test di vocabolario (Inglese)",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "bioImageLabeling": {
          "name": "Etichettatura di immagini (Biologia)",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello e esame in bianco"
        },
        "mathProofFr": {
          "name": "Dimostrazione matematica",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello e esame in bianco"
        },
        "mathProofEng": {
          "name": "Dimostrazione matematica",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello e esame in bianco"
        },
        "plotting": {
          "name": "Disegno di grafici",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello e esame in bianco"
        },
        "curveAnalysis": {
          "name": "Studio di funzioni",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello e esame in bianco"
        },
        "calculationDe": {
          "name": "Fisica",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "dictationFr": {
          "name": "Dettato — Francese",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "dictationEs": {
          "name": "Dettato — Spagnolo",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "calculationFr": {
          "name": "Calcolo",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "calculationEs": {
          "name": "Calcolo",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "calculationEn": {
          "name": "Calcolo",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "multipleChoiceDe": {
          "name": "Scelta multipla",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "multipleChoiceEn": {
          "name": "Scelta multipla",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "multipleChoiceFr": {
          "name": "Scelta multipla",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "multipleChoiceEs": {
          "name": "Scelta multipla",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "politics12German": {
          "name": "Educazione civica — Classe 12ª",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "poetry12German": {
          "name": "Analisi poetica — Classe 12ª",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "poetry12English": {
          "name": "Analisi poetica — Classe 12ª",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "poetry12French": {
          "name": "Analisi poetica — Classe 12ª",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "materialBasedEnglish": {
          "name": "Saggio basato su materiali",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        },
        "materialBasedGerman": {
          "name": "Saggio basato su materiali",
          "description": "Insieme di dati completo: consegne degli studenti, soluzione modello, schema di valutazione e esame in bianco"
        }
      }
    },
    "examEditor": {
      "savingAndRecompiling": "Salvataggio e ricompilazione…",
      "unsavedChanges": "Modifiche non salvate",
      "allChangesSaved": "Tutte le modifiche sono state salvate",
      "readOnlyBanner": "Questo esame è in modalità sola lettura: esiste già una soluzione modello, una griglia di valutazione o consegne degli studenti basate sulla struttura delle attività, quindi non è più possibile apportare modifiche qui.",
      "generatingExam": "Generazione esame…",
      "refiningExam": "Aggiornamento esame…",
      "downloadPdf": "Scarica PDF",
      "preparingPdf": "Preparazione PDF…",
      "notSaved": "Non salvato: {{message}}",
      "seeProblemsBelow": "vedi i problemi qui sotto",
      "noExam": "Nessuna verifica.",
      "noSourceYet": "Questa verifica non ha ancora una sorgente.",
      "noPreviewYet": "Nessuna anteprima compilata ancora — clicca su un blocco o un punto per modificare e generarne una.",
      "tellAiPlaceholder": "Indica all'IA cosa modificare ...",
      "delete": "Elimina",
      "applying": "Applicazione in corso …",
      "send": "Invia",
      "done": "Fatto",
      "describeAiPlaceholder": "Descrivi all'IA quale compito aggiungere qui ...",
      "add": "Aggiungi",
      "adding": "Aggiunta in corso …",
      "task": "Compito {{number}}",
      "taskNumber": "Numero del compito",
      "type": "Tipo",
      "points": "Punti",
      "lines": "Righe",
      "taskText": "Testo del compito",
      "material": "Materiale",
      "title": "Titolo",
      "usedByTasks": "Usato dai compiti (numeri separati da virgola)",
      "text": "Testo",
      "multipleChoice": "Scelta multipla",
      "removeOption": "Rimuovi opzione",
      "addOption": "+ Aggiungi opzione",
      "figureProperties": "Proprietà della figura",
      "caption": "Didascalia",
      "examSetup": "Impostazioni della verifica",
      "subject": "Materia",
      "class": "Classe",
      "duration": "Durata",
      "totalPoints": "Punteggio totale",
      "globalHints": "Indicazioni / istruzioni generali",
      "studentView": "Compila online"
    }
  },
  "TaskTypeDescs": {
    "taskFrame": "Raggruppa i sotto-esercizi, non richiede una risposta propria",
    "default": "Tipo di esercizio generale, usato quando nessun altro si adatta",
    "shortText": "Breve risposta scritta (poche frasi)",
    "essay": "Testo continuo più lungo e strutturato",
    "diagram": "Disegno tecnico, ad es. diagramma di flusso o circuito elettrico",
    "sketch": "Disegno a mano libera o schizzo",
    "gapText": "Compila il testo con lacune",
    "labelImage": "Etichetta parti di un'immagine o di un diagramma",
    "multipleChoice": "Seleziona dalle opzioni fornite",
    "imageAnalysis": "Descrivi o interpreta un'immagine",
    "mapping": "Collega gli oggetti/alternative corrispondenti",
    "legalCase": "Caso giuridico (stile parere)",
    "calculation": "Calcolo matematico o fisico",
    "mathematicalProof": "Dimostrazione matematica formale",
    "curveAnalysis": "Studio di funzioni (zeri, estremi, ...)",
    "plotting": "Traccia un grafico, una funzione o punti nel sistema di coordinate",
    "geometry": "Costruzioni o calcoli geometrici (disegno)",
    "programming": "Scrivi o analizza il codice sorgente",
    "art": "Crea un'opera d'arte o un design artistico",
    "dictation": "Scrivi il testo dettato",
    "translation": "Traduci testo o parole in un'altra lingua",
    "chemicalFormula": "Equazioni o formule chimiche",
    "music": "Leggi o scrivi note musicali",
    "literaryAnalysisPoetry": "Analizzare una poesia",
    "analysisNonFiction": "Analizzare un testo non narrativo",
    "materialBasedEssay": "Scrivere un saggio basato su materiali forniti"
  },
  "TaskTypes": {
    "taskFrame": "Cornice del compito",
    "default": "Standard",
    "shortText": "Testo breve",
    "essay": "Saggio / Tema",
    "diagram": "Diagramma",
    "sketch": "Schizzo",
    "gapText": "Testo a buchi",
    "labelImage": "Etichetta immagine",
    "multipleChoice": "Scelta multipla",
    "imageAnalysis": "Analisi dell'immagine",
    "mapping": "Associazione",
    "legalCase": "Caso legale",
    "calculation": "Calcolo",
    "mathematicalProof": "Dimostrazione matematica",
    "curveAnalysis": "Studio di funzioni",
    "plotting": "Disegna grafico",
    "geometry": "Geometria",
    "programming": "Programmazione",
    "art": "Arte",
    "dictation": "Dettato",
    "translation": "Traduzione",
    "chemicalFormula": "Formula chimica",
    "music": "Musica",
    "literaryAnalysisPoetry": "Analisi poetica",
    "analysisNonFiction": "Analisi di testo non narrativo",
    "materialBasedEssay": "Saggio basato su materiali"
  },
  "GapText": {
    "gap": "Lacuna",
    "correct": "Corretto",
    "incorrect": "Errato",
    "empty": "Vuoto",
    "points": "Punti",
    "expectedAnswer": "Risposta attesa",
    "studentAnswer": "Risposta dello studente",
    "status": "Stato"
  },
  "progress": {
    "analyzingSplit": "Analisi della divisione in corso",
    "extractingAnswers": "Estrazione delle risposte degli studenti...",
    "errorExtractingAnswers": "Errore durante l'estrazione delle risposte degli studenti",
    "answersExtracted": "Risposte degli studenti estratte",
    "extractingMasterSolution": "Estrazione dei contenuti della soluzione modello",
    "errorStructureMasterSolution": "Errore durante la creazione della struttura degli esercizi (soluzione modello)",
    "errorExtractingMasterSolution": "Errore durante l'estrazione della soluzione modello",
    "masterSolutionExtracted": "Soluzione modello estratta",
    "extractingGradingScheme": "Estrazione dei criteri di valutazione",
    "errorStructureGradingScheme": "Errore durante la creazione della struttura degli esercizi (criteri di valutazione)",
    "errorExtractingGradingScheme": "Errore durante l'estrazione dei criteri di valutazione",
    "gradingSchemeExtracted": "Criteri di valutazione estratti",
    "noUsableMasterSolution": "Nessun contenuto utilizzabile della soluzione modello rilevato. Controlla il file o regola l'assegnazione.",
    "noUsableGradingScheme": "Nessun criterio di valutazione utilizzabile rilevato. Controlla il file o regola l'assegnazione.",
    "analyzingStructure": "Analisi della struttura dell'esame in corso",
    "noSubmissions": "Nessuna consegna presente",
    "errorStructureAnalysis": "Errore durante l'analisi della struttura dell'esame",
    "noTasksInStructure": "Nessun esercizio trovato nell'analisi della struttura",
    "extractingTaskDescriptions": "Estrazione delle descrizioni degli esercizi",
    "errorTaskDescriptions": "Errore durante l'estrazione delle descrizioni degli esercizi",
    "taskDescriptionsExtracted": "Descrizioni degli esercizi estratte",
    "taskStructureCreated": "Struttura degli esercizi creata",
    "waitingForStructureConfirmation": "In attesa di conferma della struttura dell'esame da parte dell'utente",
    "structureConfirmed": "Struttura dell'esame confermata",
    "structureConfirmationTimeout": "Il tempo per la conferma della struttura dell'esame è scaduto",
    "errorWaitingStructureConfirmation": "Errore durante l'attesa della conferma della struttura dell'esame",
    "errorProcessingStructureConfirmation": "Errore durante l'elaborazione della conferma della struttura dell'esame",
    "errorCreatingTaskStructure": "Errore durante la creazione della struttura degli esercizi",
    "pipelineFailedPrematurely": "Pipeline fallita prematuramente",
    "assignmentConfirmed": "Assegnazione confermata",
    "gradingRunning": "Valutazione in corso...",
    "gradingTaskX": "Valutazione dell'esercizio {{taskNumber}} in corso...",
    "gradingCompleted": "Valutazione completata",
    "gradingTaskXCompleted": "Valutazione per l'esercizio {{taskNumber}} completata"
  },
  "upload": {
    "noExamId": "Nessun ID esame trovato",
    "noFileSelected": "Nessun file selezionato",
    "processingFailed": "Impossibile elaborare il file",
    "invalidFileType": "Tipo di file non valido. Seleziona un file PNG o PDF.",
    "uploadError": "Errore durante il caricamento del file",
    "studentName": "Studente {{index}}",
    "noExamIdForReupload": "Errore: Nessun ID esame disponibile per il ricaricamento.",
    "reuploadCancelled": "SYSTEM INFO: Annullamento del caricamento elaborato.",
    "reuploadCancelFailed": "SYSTEM INFO: Impossibile elaborare completamente l'annullamento del caricamento.",
    "filesMissing": "SYSTEM BLOCK: I seguenti file non sono stati trovati nella memoria di caricamento: {{files}}. Assicurati che i nomi dei file corrispondano esattamente ai file caricati.",
    "assignmentMismatch": "SYSTEM BLOCK: Le seguenti assegnazioni di file non corrispondono all'ultimo suggerimento. Chiama send_assignment_confirmation_message e conferma la nuova assegnazione con l'utente.\n{{lines}}",
    "reuploadStarted": "Il ricaricamento dei file è stato avviato in background. {{extra}}",
    "splitStarted": "La divisione è stata avviata per le consegne degli studenti.",
    "assignmentProposalSent": "Messaggio con proposta di assegnazione inviato.",
    "assignmentConfirmationMessage": "Non sono ancora sicuro dell'assegnazione dei file e vorrei che tu controllassi rapidamente.\n\nConferma nell'area drag-and-drop se l'assegnazione proposta è corretta o modificala lì. Dopodiché potrò continuare immediatamente.",
    "assignmentProposalFallback": "Controlla la mia proposta di assegnazione e conferma il collegamento dei file.",
    "categorySubmissions": "Consegne degli studenti",
    "categoryMasterSolution": "Soluzione modello",
    "categoryGradingScheme": "Schema di valutazione",
    "categoryBlankExam": "Esame in bianco",
    "lowConfidenceListFormat": "'{{file}}' (pianificato come {{category}})",
    "mismatchFormat": "- {{name}}: proposto di recente come \"{{proposed}}\", ora fornito come \"{{supplied}}\""
  },
  "splitIssues": {
    "unknownStudent": "Studente sconosciuto",
    "studentNumber": "Studente {{number}}",
    "pageAssignmentError": "Non tutte le pagine sono state assegnate esattamente una volta",
    "nonConsecutive": "Pagine non consecutive assegnate a {{names}} (riordinamento da parte dell'agente)",
    "uncertainty": "Incertezza con {{names}}",
    "outlierLongExtremeSingle": "La consegna di {{names}} è estremamente lunga",
    "outlierLongExtremePlural": "Le consegne di {{names}} sono estremamente lunghe",
    "outlierShortExtremeSingle": "La consegna di {{names}} è estremamente corta",
    "outlierShortExtremePlural": "Le consegne di {{names}} sono estremamente corte",
    "outlierLongSingle": "La consegna di {{names}} è insolitamente lunga",
    "outlierLongPlural": "Le consegne di {{names}} sono insolitamente lunghe",
    "outlierShortSingle": "La consegna di {{names}} è insolitamente corta",
    "outlierShortPlural": "Le consegne di {{names}} sono insolitamente corte",
    "missingStudentNameSingle": "Impossibile estrarre il nome per {{missingCount}} studente su {{totalCount}}",
    "missingStudentNamePlural": "Impossibile estrarre il nome per {{missingCount}} studenti su {{totalCount}}",
    "splitAgentFailure": "Errore dell'agente di divisione{{suffix}}",
    "errorPrefix": "Errore",
    "warningPrefix": "Avviso",
    "parseErrorFallback": "Impossibile elaborare i dati. Controlla l'assegnazione nel Canvas.",
    "messageError": "Ho trovato {{count}} studenti con {{range}} pagine ciascuno, ma si è verificato un problema con l'assegnazione automatica delle pagine:\n{{problem}}\n\nControlla l'assegnazione nel Canvas corrispondente e correggila manualmente se necessario. Una volta terminato, conferma nella chat o tramite il pulsante per continuare.",
    "messageWarning": "Ho trovato {{count}} studenti con {{range}} pagine ciascuno, ma ci sono i seguenti avvisi:\n{{problem}}\n\nSe desideri, puoi verificare gli avvisi nel Canvas di assegnazione. Altrimenti, basta confermare per continuare.",
    "messageSuccess": "Ho trovato {{count}} studenti con {{range}} pagine ciascuno. L'assegnazione è chiara. È stato possibile estrarre il nome di tutti gli studenti. Conferma per continuare.",
    "confirmationRequested": "Conferma di divisione richiesta",
    "splitAgentFailed": "L'assegnazione automatica delle consegne degli studenti è fallita. Riprova il caricamento più tardi."
  },
  "structureIssues": {
    "pointsExplanation": "\n\n**Riguardo ai punti:** Ho rilevato punti per alcune attività. Se carichi uno schema di valutazione con i punteggi (o lo hai già fatto), i punti verranno presi da lì; puoi quindi ignorare i punti nel canvas. Sono rilevanti solo se il tuo schema di valutazione non li contiene o se vuoi generarne uno.\n\nRegole di assegnazione: per ogni attività, assegna punti a tutte le sottoattività dirette in modo che sommino al totale dell'attività superiore, oppure a nessuna. Se non assegni punti alle sottoattività ma solo un totale, l'IA li distribuirà automaticamente durante la generazione dello schema di valutazione.",
    "textCutoff": "Testo dell'esercizio incompleto",
    "missingInformation": "informazioni mancanti",
    "imageUnreadable": "Immagine illeggibile",
    "task": "Esercizio",
    "mainTasks_one": "Ho rilevato {{mainCount}} esercizio principale.",
    "mainTasks_other": "Ho rilevato {{mainCount}} esercizi principali.",
    "mainAndSubTasks_one": "Ho rilevato {{mainCount}} esercizi principali e {{subCount}} sotto-esercizio.",
    "mainAndSubTasks_other": "Ho rilevato {{mainCount}} esercizi principali e {{subCount}} sotto-esercizi.",
    "intro": "### Ho identificato la folgende struttura degli esercizi:\n\n{{countText}}",
    "problemsIntro": "\n\nSi sono verificati i seguenti problemi durante il rilevamento degli esercizi: {{warnings}}. Guarda le incertezze nel Canvas, modificale se necessario e poi conferma tramite il pulsante o nella chat.",
    "uncertaintyIntro": "\n\nCi sono incertezze in {{labels}} durante il rilevamento degli esercizi. Guarda le incertezze nel Canvas, modificale se necessario e poi conferma tramite il pulsante o nella chat.",
    "success": "\n\nNon si sono verificati problemi durante il rilevamento degli esercizi. Se lo desideri, puoi comunque esaminarli più da vicino nel Canvas, altrimenti conferma tramite il pulsante o nella chat."
  },
  "chatMessages": {
    "emptyState": "Avvia una conversazione inserendo un messaggio qui sotto",
    "newMessage": "Nuovo messaggio",
    "cancel": "Annulla",
    "send": "Invia",
    "edit": "Modifica",
    "editInCanvas": "Modifica nel Canvas",
    "confirmed": "Confermato",
    "confirm": "Conferma",
    "confirmAssignment": "Conferma assegnazione",
    "giveFeedback": "Invia feedback",
    "feedbackTitle": "Invia feedback",
    "feedbackDescription": "Facci sapere come possiamo migliorare esta risposta.",
    "feedbackPlaceholder": "Il tuo feedback qui...",
    "feedbackSubmit": "Invia feedback",
    "submitAssignmentConfirmation": "Confermo la divisione delle pagine e l'assegnazione agli studenti. Per favore, continua.",
    "submitStructureConfirmation": "Confermo la struttura degli esercizi",
    "studentSubmissions": "Consegne degli studenti",
    "masterSolution": "Soluzione modello",
    "gradingScheme": "Schema di valutazione",
    "blankExam": "Esame in bianco",
    "confirmedAssignmentIntro": "L'assegnazione dei file confermata:",
    "assignmentIntro": "Ho assegnato i file come segue. Controlla l'assegnazione e confermala:"
  },
  "AuthModal": {
    "loginError": "E-mail o password errate.",
    "signupFailed": "Registrazione fallita. Riprova.",
    "passwordMismatch": "Le password non corrispondono.",
    "forgotPasswordProblem": "Si è verificato un problema. Riprova più tardi.",
    "waitlistTitle": "Sei in lista!",
    "waitlistDesc": "Ti contatteremo non appena inizierà la fase successiva.",
    "waitlistInactive": "Lista d'attesa attualmente disattivata.",
    "backToLogin": "Torna al login",
    "linkSentTitle": "Link inviato!",
    "linkSentDesc": "Ho capito",
    "forgotPasswordTitle": "Password dimenticata?",
    "requestLink": "Richiedi link",
    "welcomeBack": "Bentornato",
    "createAccount": "Crea un account",
    "emailLabel": "E-mail",
    "passwordLabel": "Password",
    "forgotPasswordLink": "Password dimenticata?",
    "loginButton": "Accedi",
    "firstNameLabel": "Nome",
    "lastNameLabel": "Cognome",
    "schoolLabel": "Scuola",
    "subjectsLabel": "Materie",
    "confirmPasswordLabel": "Conferma",
    "signupButton": "Registrati",
    "registerHere": "Registrati qui",
    "loginHere": "Accedi qui",
    "continueGuest": "Continua senza registrarti →"
  },
  "FeedbackPage": {
    "alerts": {
      "imageTooLarge": "L'immagine \"{{name}}\" è troppo grande (max 5 MB).",
      "previewError": "Impossibile creare l'anteprima per {{name}}.",
      "submitError": "Qualcosa è andato storto. Riprova."
    },
    "success": {
      "title": "Grazie mille per il tuo feedback!",
      "description": "Abbiamo ricevuto il tuo messaggio. Il tuo contributo ci aiuta enormemente a migliorare Gradias ogni giorno.",
      "backButton": "Torna all'esame"
    },
    "header": {
      "title": "Invia feedback"
    },
    "content": {
      "description": "Hai notato un errore, hai un'idea brillante o vuoi semplicemente dirci qualcosa? Leggiamo ogni messaggio!"
    },
    "categories": {
      "title": "Di cosa si tratta?",
      "bug": {
        "title": "Errore / Bug",
        "desc": "Qualcosa non funziona"
      },
      "feature": {
        "title": "Idea / Suggerimento",
        "desc": "Una nuova funzionalità"
      },
      "general": {
        "title": "Altro",
        "desc": "Feedback generale"
      }
    },
    "message": {
      "title": "Il tuo messaggio",
      "placeholder": "Descrivi la tua richiesta nel modo più dettagliato possibile..."
    },
    "upload": {
      "title": "Allega screenshot (Opzionale)",
      "clickToSelect": "Clicca per selezionare le immagini",
      "formatConstraint": "PNG, JPG fino a max 5 MB per immagine",
      "attachedImages": "Immagini allegate",
      "removeImage": "Rimuovi immagine"
    },
    "submit": {
      "sending": "Invio in corso...",
      "send": "Invia feedback"
    }
  },
  "ConfirmationReplies": {
    "split": {
      "confirmed": "L'assegnazione dell'esame e il numero di studenti sono stati confermati con successo. L'estrazione della struttura degli esercizi può ora essere avviata. Ringrazia l'utente per la conferma dell'assegnazione e informalo nella chat che l'estrazione della struttura degli esercizi sta per iniziare.",
      "pending": "L'assegnazione dell'esame e il numero di studenti non sono ancora confermati."
    },
    "structure": {
      "masterAndGrading": "La struttura degli esercizi è stata confermata con successo. L'estrazione continua in background. Una soluzione modello e una chiave di valutazione sono già state caricate e vengono elaborate in background. Ringrazia brevemente l'utente per la conferma della struttura degli esercizi e informalo che l'estrazione continuerà. Suggerisci di avviare la correzione.",
      "masterOnly": "La struttura degli esercizi è stata confermata con successo. L'estrazione continua in background. Una soluzione modello è già stata caricata, ma manca ancora lo schema di valutazione. Ringrazia brevemente l'utente per la conferma della struttura degli esercizi e informalo che l'estrazione continuerà. Suggerisci di creare uno schema di valutazione basato sull'IA como passo successivo.",
      "gradingOnly": "La struttura degli esercizi è stata confermata con successo. L'estrazione continua in background. Uno schema di valutazione è già stato caricato, ma manca ancora la soluzione modello. Ringrazia brevemente l'utente per la conferma della struttura degli esercizi e informalo che l'estrazione continuerà. Suggerisci di creare una soluzione modello basata sull'IA.",
      "none": "La struttura degli esercizi è stata confermata con successo. L'estrazione continua in background. Manca ancora la soluzione modello. Ringrazia brevemente l'utente per la conferma della struttura degli esercizi, informalo che l'estrazione continuerà e chiedigli se nel passo successivo, una volta completata l'estrazione, desidera generare una soluzione modello basata sull'IA o se desidera caricare una soluzione modello tramite la graffetta nel campo di input. Menziona nella tua risposta come l'utente può caricare la soluzione modello, ovvero con la graffetta nel campo di testo della chat."
    },
    "errors": {
      "notConfirmed": "Confirmation flag is false; nothing to do.",
      "missingIdentifiers": "Missing required identifiers for confirmation.",
      "missingSplitMessage": "Errore: Nessun messaggio di conferma della divisione associato trovato.",
      "missingStructureMessage": "Errore: Nessun messaggio di conferma della struttura associato trovato.",
      "structureContentMissing": "Errore: Impossibile caricare il messaggio di conferma della struttura.",
      "splitFailure": "Errore durante la conferma della divisione.",
      "structureFailure": "Errore durante la conferma della struttura."
    }
  },
  "toolFallbackDesc": {
    "default": "Esegui passaggio dello strumento",
    "set_metadata": "Metadati dell'esame",
    "create_exam": "Crea il compito ora",
    "generate_master_solution": "Crea soluzione modello ora",
    "refine_master_solution": "Affina specificamente la soluzione modello",
    "generate_grading_scheme": "Crea schema di valutazione ora",
    "refine_grading_scheme": "Affina specificamente lo schema di valutazione",
    "run_grading_agent": "Esegui valutazione",
    "set_task_score": "Imposta punteggio manualmente",
    "open_canvas": "Apri vista Canvas",
    "update_open_task_content": "Aggiorna direttamente il testo dell'esercizio",
    "send_assignment_confirmation_message": "Richiedi conferma dell'assegnazione dei file",
    "process_files": "Elabora i file caricati",
    "confirm_split_in_chat": "Conferma assegnazione nella chat",
    "confirm_structure_in_chat": "Conferma struttura nella chat",
    "query_exams": "Recupera dati esame",
    "query_submissions": "Recupera consegne degli studenti",
    "get_available_options": "Recupera opzioni disponibili",
    "get_task_types": "Recupera tipi di esercizio",
    "download_ms_gs": "Scarica soluzione modello/schema di valutazione",
    "download_summary_reports": "Scarica report di valutazione",
    "save_teacher_memory": "Ricorda preferenza",
    "get_teacher_memory": "Consulta preferenze",
    "delete_teacher_memory": "Elimina preferenze",
    "reprocess_errored_submissions": "Rielabora consegne con errori"
  },
  "Subjects": {
    "math": "Matematica",
    "physics": "Fisica",
    "chemistry": "Chimica",
    "biology": "Biologia",
    "history": "Storia",
    "geography": "Geografia",
    "english": "Inglese",
    "german": "Tedesco",
    "french": "Francese",
    "spanish": "Spagnolo",
    "computer_science": "Informatica",
    "social_studies": "Studi sociali",
    "other": "Altro"
  },
  "ExamNotifications": {
    "newMessage": "Nuovo messaggio"
  },
  "LanguageUseTemplates": {
    "essay": "Livelli di competenza · Resa espositiva\n\n* eccellente:\n  - Il testo è strutturato in modo chiaro e logico, con collegamenti efficaci tra le sezioni.\n  - Il linguaggio specialistico è utilizzato con sicurezza e precisione.\n  - Le citazioni sono integrate correttamente e introdotte nel contesto; i riferimenti includono il numero di riga.\n  - La sintassi è varia, stilisticamente sicura e adeguata all'oggetto letterario.\n  - Grammatica, ortografia e punteggiatura sono quasi prive di errori.\n* buono:\n  - Il testo è strutturato in modo coerente.\n  - Il linguaggio specialistico è utilizzato per lo più con sicurezza.\n  - Le citazioni sono impiegate in modo adeguato e correttamente documentate.\n  - La sintassi è corretta e varia.\n  - Poche infrazioni a grammatica, ortografia e punteggiatura.\n* sufficiente (soddisfacente):\n  - La struttura è riconoscibile, ma non è coerente in modo continuo.\n  - Il linguaggio specialistico è utilizzato in modo funzionale, ma non sempre preciso.\n  - Vengono utilizzate citazioni, i riferimenti sono per lo più corretti.\n  - La sintassi è per lo più corretta, a tratti monotona.\n  - Le infrazioni a grammatica, ortografia e punteggiatura non compromettono la comprensione.\n* appena sufficiente:\n  - La struttura è riconoscibile solo in modo rudimentale.\n  - Il linguaggio specialistico è utilizzato solo parzialmente o in modo impreciso.\n  - Le citazioni sono incoerenti o documentate in modo incompleto.\n  - La sintassi è monotona, con frequenti incertezze.\n  - La correttezza linguistica è limitata; la comprensione è occasionalmente compromessa.\n* scarso:\n  - L'esposizione è in gran parte priva di struttura.\n  - Il linguaggio specialistico è in gran parte assente o utilizzato in modo errato.\n  - Le citazioni sono assenti o errate.\n  - Le carenze linguistiche compromettono notevolmente la comprensione.\n* insufficiente:\n  - L'esposizione è talmente carente che il lavoro risulta a malapena comprensibile.\n  - I requisiti di base per un saggio scritto di interpretazione letteraria non sono riconoscibili.",
    "analysisNonFiction": "Livelli di competenza · Resa espositiva\n\n* eccellente:\n  - Il testo è strutturato in modo chiaro e logico, con collegamenti efficaci tra le sezioni.\n  - Il linguaggio specialistico è utilizzato con sicurezza e precisione.\n  - Le citazioni sono integrate correttamente e introdotte nel contesto; i riferimenti includono il numero di riga.\n  - La sintassi è varia, stilisticamente sicura e adeguata all'oggetto letterario.\n  - Grammatica, ortografia e punteggiatura sono quasi prive di errori.\n* buono:\n  - Il testo è strutturato in modo coerente.\n  - Il linguaggio specialistico è utilizzato per lo più con sicurezza.\n  - Le citazioni sono impiegate in modo adeguato e correttamente documentate.\n  - La sintassi è corretta e varia.\n  - Poche infrazioni a grammatica, ortografia e punteggiatura.\n* sufficiente (soddisfacente):\n  - La struttura è riconoscibile, ma non è coerente in modo continuo.\n  - Il linguaggio specialistico è utilizzato in modo funzionale, ma non sempre preciso.\n  - Vengono utilizzate citazioni, i riferimenti sono per lo più corretti.\n  - La sintassi è per lo più corretta, a tratti monotona.\n  - Le infrazioni a grammatica, ortografia e punteggiatura non compromettono la comprensione.\n* appena sufficiente:\n  - La struttura è riconoscibile solo in modo rudimentale.\n  - Il linguaggio specialistico è utilizzato solo parzialmente o in modo impreciso.\n  - Le citazioni sono incoerenti o documentate in modo incompleto.\n  - La sintassi è monotona, con frequenti incertezze.\n  - La correttezza linguistica è limitata; la comprensione è occasionalmente compromessa.\n* scarso:\n  - L'esposizione è in gran parte priva di struttura.\n  - Il linguaggio specialistico è in gran parte assente o utilizzato in modo errato.\n  - Le citazioni sono assenti o errate.\n  - Le carenze linguistiche compromettono notevolmente la comprensione.\n* insufficiente:\n  - L'esposizione è talmente carente che il lavoro risulta a malapena comprensibile.\n  - I requisiti di base per un saggio scritto di interpretazione letteraria non sono riconoscibili.",
    "genericGroup": "Livelli di competenza · Resa espositiva\n\n* eccellente:\n  - Il testo è strutturato in modo chiaro e logico, con collegamenti efficaci tra le sezioni.\n  - Il linguaggio specialistico è utilizzato con sicurezza e precisione.\n  - Le citazioni sono integrate correttamente e introdotte nel contesto; i riferimenti includono il numero di riga.\n  - La sintassi è varia, stilisticamente sicura e adeguata all'oggetto letterario.\n  - Grammatica, ortografia e punteggiatura sono quasi prive di errori.\n* buono:\n  - Il testo è strutturato in modo coerente.\n  - Il linguaggio specialistico è utilizzato per lo più con sicurezza.\n  - Le citazioni sono impiegate in modo adeguato e correttamente documentate.\n  - La sintassi è corretta e varia.\n  - Poche infrazioni a grammatica, ortografia e punteggiatura.\n* sufficiente (soddisfacente):\n  - La struttura è riconoscibile, ma non è coerente in modo continuo.\n  - Il linguaggio specialistico è utilizzato in modo funzionale, ma non sempre preciso.\n  - Vengono utilizzate citazioni, i riferimenti sono per lo più corretti.\n  - La sintassi è per lo più corretta, a tratti monotona.\n  - Le infrazioni a grammatica, ortografia e punteggiatura non compromettono la comprensione.\n* appena sufficiente:\n  - La struttura è riconoscibile solo in modo rudimentale.\n  - Il linguaggio specialistico è utilizzato solo parzialmente o in modo impreciso.\n  - Le citazioni sono incoerenti o documentate in modo incompleto.\n  - La sintassi è monotona, con frequenti incertezze.\n  - La correttezza linguistica è limitata; la comprensione è occasionalmente compromessa.\n* scarso:\n  - L'esposizione è in gran parte priva di struttura.\n  - Il linguaggio specialistico è in gran parte assente o utilizzato in modo errato.\n  - Le citazioni sono assenti o errate.\n  - Le carenze linguistiche compromettono notevolmente la comprensione.\n* insufficiente:\n  - L'esposizione è talmente carente che il lavoro risulta a malapena comprensibile.\n  - I requisiti di base per un saggio scritto di interpretazione letteraria non sono riconoscibili.",
    "materialBasedEssay": "Scrittura basata su materiali (redazione di testi argomentativi / informativi)\n\nResa di contenuto e uso dei materiali (comprensione / struttura del testo):\n* L'introduzione è concisa, suscita l'interesse del lettore e conduce al tema (si evitano transizioni di maniera).\n* È riconoscibile una struttura sensata, corrispondente a tutti gli elementi della tipologia testuale richiesta (ad es. commento, saggio, articolo).\n* Il tema e la relativa problematica vengono delineati chiaramente all'inizio.\n* I concetti fondamentali importanti vengono spiegati adeguatamente quando necessario.\n* Tutti i materiali forniti vengono presi in considerazione e integrati nel testo in modo sensato e corretto nel contenuto.\n* È garantita la trasparenza nelle affermazioni riportate (citazione corretta, parafrasi e riferimento alle fonti).\n* Si distingue chiaramente tra l'esposizione dei fatti, l'argomentazione e la valutazione personale.\n* L'argomentazione è ampia e articolata (considera vari aspetti del tema e possibili controargomentazioni).\n* I singoli argomenti risultano convincenti per il pubblico destinatario, chiaramente strutturati, spiegati e sostenuti da prove/esempi.\n* Oltre agli argomenti tratti dai materiali, vengono apportati argomenti propri e conoscenze specialistiche personali.\n* L'argomentazione viene ricondotta, alla fine, a una conclusione, eventualmente seguita da una prospettiva futura.\n\nResa linguistica e configurazione testuale (resa espositiva):\n* La configurazione linguistica corrisponde alla tipologia testuale richiesta, con linguaggio chiaro, preciso e formulazioni personali.\n* Il vocabolario, la padronanza dei termini specialistici e lo stile funzionale sono precisi, articolati e stilisticamente adeguati.\n* La costruzione delle frasi è gestibile, varia e grammaticalmente complessa.\n* Gli errori normativi (di grammatica, ortografia e punteggiatura) non compromettono la fluidità della lettura.",
    "literaryAnalysisPoetry": "Resa espositiva\n* 1. Il candidato struttura il proprio testo in modo coerente, logico, rigoroso e con chiarezza di pensiero:\n  - ponderazione adeguata dei sotto-compiti nello svolgimento\n  - disposizione strutturata e adeguatamente ponderata del lavoro\n  - collegamento coerente tra le singole fasi di lavoro\n  - collegamento logico coerente tra le frasi\n* 2. Il candidato si esprime nel rispetto dei requisiti del linguaggio specialistico e della metodologia disciplinare:\n  - separazione tra il livello dell'azione e il metalivello\n  - collegamento motivato tra affermazioni descrittive, interpretative e valutative\n  - uso della terminologia specialistica in un contesto pertinente\n  - rispetto dei tempi verbali\n  - resa corretta del discorso riportato (modalità)\n* 3. Il candidato sostiene le proprie affermazioni con citazioni appropriate e corrette:\n  - uso sensato di citazioni complete o abbreviate con funzione argomentativa\n* 4. Il candidato si esprime con precisione linguistica generale, sicurezza stilistica e differenziazione concettuale:\n  - uno stile di scrittura oggettivo e distaccato\n  - un registro proprio della lingua scritta\n  - capacità di espressione concettuale astratta\n* 5. Il candidato si esprime con sicurezza lessicale e sintattica, in modo vario e complesso (pur restando chiaro).\n* 6. Il candidato scrive con correttezza linguistica."
  },
  "LatexEditor": {
    "insertFormula": "Formula",
    "insertFormulaHint": "Inserisci una nuova formula nella posizione del cursore",
    "switchToRawLatex": "Passa al LaTeX grezzo",
    "switchToVisualEditor": "Passa all'editor visivo",
    "naturalLanguageHint": "Descrivi questa formula in linguaggio naturale",
    "naturalLanguagePlaceholder": "es. \"integrale da 0 a 10 di x²\"",
    "naturalLanguageError": "Traduzione non riuscita. Riprova.",
    "insert": "Inserisci",
    "removeFormula": "Rimuovi formula",
    "cancel": "Annulla"
  },
  "StudentExam": {
    "loading": "Caricamento della verifica…",
    "examFallbackTitle": "Verifica",
    "classLabel": "Classe {{class}}",
    "namePlaceholder": "Il tuo nome",
    "answeredCount": "{{answered}} / {{total}} svolte",
    "submit": "Consegna",
    "signInRequiredTitle": "Accesso richiesto",
    "signInRequiredBody": "Accedi per svolgere questa verifica.",
    "signInAction": "Vai all’accesso",
    "unavailableTitle": "Non disponibile",
    "submittedTitle": "Consegnata",
    "submittedBody": "Le tue risposte sono state salvate e sono pronte per la correzione.",
    "errors": {
      "loadFailed": "Non è stato possibile caricare la verifica.",
      "notFound": "Questa verifica non esiste.",
      "notSignedIn": "Non hai effettuato l’accesso.",
      "noAccess": "Verifica non trovata o accesso negato.",
      "noTasks": "Questa verifica non contiene ancora esercizi.",
      "uploadedExam": "Questa verifica è stata caricata e non creata, quindi non può essere svolta online.",
      "studentsOnly": "La compilazione online è disponibile solo per gli account studente.",
      "renderFailed": "Non è stato possibile visualizzare la verifica.",
      "unreadableAnswers": "Non è stato possibile leggere le risposte.",
      "submitFailed": "Consegna non riuscita."
    },
    "canvas": {
      "undo": "Annulla",
      "clear": "Cancella",
      "pen": "Penna",
      "eraser": "Gomma",
      "redo": "Ripeti",
      "zoom": "Disegna ingrandito",
      "zoomClose": "Chiudi vista ingrandita",
      "penWidth": "Spessore {{width}}"
    }
  }
}
